import { render, staticRenderFns } from "./overviewInfoBox.vue?vue&type=template&id=1c1b61c4&"
import script from "./overviewInfoBox.vue?vue&type=script&lang=js&"
export * from "./overviewInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./overviewInfoBox.vue?vue&type=style&index=0&id=1c1b61c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports